<div class="card border-0 rounded-0 h-10">
    <form (ngSubmit)="onSubmit()" *ngIf="assessmentSearchForm" [formGroup]="assessmentSearchForm">
        <div class="card-body">

            <div class="col-md-12 d-flex flex-wrap">
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">ওয়ার্ড অনুসারে</label>
                    <select name="ward_number" class="form-control rounded-0" formControlName="ward_number">
                    <option value="0">সব ওয়ার্ড</option>
                    <option *ngFor="let ward of wardList" [value]="ward.ward_number">
                      {{ward.ward_name}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">হোল্ডিং নং অনুসারে</label>
                    <input formControlName="holding_number" type="text" name="requestedPersonName" class="form-control rounded-0" id="husername" aria-describedby="emailHelp" placeholder="হোল্ডিং নং">
                </div>
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">ক্রমিক নং শুরু</label>
                    <input formControlName="serial_no_start" type="number" name="requestedPersonName" class="form-control rounded-0" id="husername" aria-describedby="emailHelp" placeholder="শুরু">
                </div>
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">ক্রমিক নং শেষ</label>
                    <input formControlName="serial_no_end" type="number" name="requestedPersonName" class="form-control rounded-0" id="husername" aria-describedby="emailHelp" placeholder="শেষ">
                </div>
            </div>

        </div>
        <div class="col-md-12">

            <div class="d-flex justify-content-center">
                <button type="submit" class="btn btn-lightning rounded-0 mb-2 mr-2">খুঁজুন</button>
                <button [useExistingCss]="true" [printStyle]="{h1:{'color':'red'}}" printSectionId="demo" ngxPrint class="btn btn-lightning rounded-0 mb-2 mr-2">প্রিন্ট করুন</button>

            </div>

        </div>
    </form>
</div>

<div id="demo" class="card border-0 rounded-0 h-10">
    <div class="card-body">
        <div>
            <div *ngFor="let assessment of assessmentList" class="container">
                <img class="image-class" [src]='upCardBanner' alt="Holding Card">
                <div class="name">{{assessment.name}}</div>
                <div class="holding-no">{{assessment.holding_number}}</div>
                <div class="ward-no">{{unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(assessment.ward_number.toString())}}</div>
                <div class="village">{{assessment.gram_or_rasta}}</div>
                <div class="qr-code">
                    <qrcode [elementType]="'svg'" [qrdata]="unionDomain.qrCodeInitialString+assessment.qr_code" [width]="60" [errorCorrectionLevel]="'L'"></qrcode>
                </div>
                <!-- <qrcode [qrdata]="myAngularxQrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode> -->
            </div>
        </div>
    </div>
</div>